import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/star/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-443910a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-bar" }
const _hoisted_2 = { class: "buttons-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存策略")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除策略")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("订阅信号")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消订阅")
const _hoisted_7 = { class: "modal-content-wrapper" }
const _hoisted_8 = { class: "star-dialog-header" }
const _hoisted_9 = { class: "star-dialog-title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "star-dialog-logo"
}, null, -1))
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "priority-label" }, "策略选择", -1))
const _hoisted_13 = {
  key: 1,
  class: "error-text-container"
}
const _hoisted_14 = { class: "error-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 上述策略仅在对应回测区间内有效，不构成投资建议或收益承诺。请投资者审慎决策、理性投资，自主承担投资风险。 ", -1))
const _hoisted_16 = { class: "confirm-modal-body" }
const _hoisted_17 = { class: "confirm-title" }
const _hoisted_18 = { class: "confirm-btns" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_21 = { class: "confirm-modal-body" }
const _hoisted_22 = { class: "confirm-title" }
const _hoisted_23 = { class: "confirm-countdown" }

import { ref, reactive, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import { strategyAction } from '@/api/starresultApi'
import store from '@/store/index'
import { useStarTip } from '@/utils/useStarTip'
import { useStarRouter } from '@/utils/useStarTheme'
import StarTipDialog from '@/components/star/StarTipDialog.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionFooter',
  props: {
    isDark: { type: Boolean },
    aiPriority: null,
    strategyDetails: null
  },
  emits: ["refresh"],
  setup(__props: any, { emit }: { emit: ({ (e: 'refresh'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDark: boolean
  aiPriority?: number
  strategyDetails?: Record<string, any>
}





const route = useRoute()
const { starPush } = useStarRouter()
// 从 strategyDetails 对象中取各字段，避免响应式丢失问题
const pageType = computed(() => Number(props.strategyDetails?.pageType))
const isSubscribed = computed(() => props.strategyDetails?.isSubscribed === true)
const strategyTitle = computed(() => props.strategyDetails?.title)
 const strategyNamereq = computed(() => props.strategyDetails?.comResult?.req?.strategyName)
const quantType = computed(() => props.strategyDetails?.quantType)
const visible = ref(false)
const mode = ref<'save' | 'subscribe'>('save')
const strategyName = ref('')
const selectedPriority = ref<number | undefined>(1)

const errorMessages = ref<string[]>([])
const selectError = ref('')
const inputErrors = computed(() => errorMessages.value)
const loadingMap = reactive({ save: false, del: false, sub: false, unsub: false })

const confirmConfig = reactive<{
  visible: boolean
  title: string
  loading: boolean
  onOk: () => void
}>({
  visible: false,
  title: '',
  loading: false,
  onOk: () => { },
})
const deleteCountdown = ref(0)
const successMessage = ref('')
let deleteTimer: ReturnType<typeof setInterval> | null = null

const { tipDialog, showQrDialog, handleBacktestStatus } = useStarTip()

const priorityOptions = [
  { value: 1, label: '进取型' },
  { value: 2, label: '稳健型' },
  { value: 3, label: '均衡型' },
]

const openModal = (m: 'save' | 'subscribe') => {
  mode.value = m
  // 自动填充：title + 今天日期（格式 YYYYMMDD）
  const today = new Date()
  const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`
  strategyName.value = strategyNamereq.value ? `${strategyNamereq.value}` :  `${strategyTitle.value}${dateStr}`
  errorMessages.value = []
  selectError.value = ''
  selectedPriority.value = props.aiPriority || 1
  visible.value = true
}

const handleInput = () => {
  if (strategyName.value.length > 50) {
    strategyName.value = strategyName.value.slice(0, 50)
  }
  if (errorMessages.value.length > 0) {
    errorMessages.value = []
  }
}

function has123(input: any) {
  const s = String(input);
  return s.includes('1') || s.includes('2') || s.includes('3');
}

// Task 3.1: 订阅信号 - isfrom=1 弹窗订阅并保存，isfrom=2 直接订阅
const handleSub = async () => {
  const isfrom = route.query.isfrom as string
  if (isfrom === '1') {
    // 弹窗，走 subsave 逻辑
    openModal('subscribe')
    emit('refresh')
    return
  }
  // isfrom=2 或默认：直接订阅
  loadingMap.sub = true
  const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || store.state.loginInfo.token
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
  try {
    const res: any = await strategyAction({
      data: { taskID, action: 'sub' },
      headers: { token, username },
    })
    message.success(res.data?.toast || '订阅成功')
    emit('refresh')
  } catch (error: any) {
    message.error(error.message || '网络请求失败')
  } finally {
    loadingMap.sub = false
  }
}

// Task 4.2: 取消订阅 - 先弹确认弹窗
const handleUnsub = () => {
  confirmConfig.title = '您确定要取消订阅吗？'
  confirmConfig.loading = false
  confirmConfig.onOk = async () => {
    confirmConfig.loading = true
    const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
    const token = (route.query.token as string) || store.state.loginInfo.token
    const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
    loadingMap.unsub = true
    try {
      await strategyAction({
        data: { taskID, action: 'unsub' },
        headers: { token, username },
      })
      confirmConfig.visible = false
      emit('refresh')
    } catch (error: any) {
      message.error(error.message || '网络请求失败')
    } finally {
      confirmConfig.loading = false
      loadingMap.unsub = false
    }
  }
  confirmConfig.visible = true
}

// Task 5.1: 删除策略 - 先弹确认弹窗，成功后倒计时跳首页
const handleDel = () => {
  confirmConfig.title = '您确定要删除该策略吗？'
  confirmConfig.loading = false
  confirmConfig.onOk = async () => {
    confirmConfig.loading = true
    const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
    const token = (route.query.token as string) || store.state.loginInfo.token
    const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
    loadingMap.del = true
    try {
      await strategyAction({
        data: { taskID, action: 'del' },
        headers: { token, username },
      })
      confirmConfig.visible = false
      successMessage.value = '删除成功'
      deleteCountdown.value = 3
      deleteTimer = setInterval(() => {
        deleteCountdown.value--
        if (deleteCountdown.value <= 0) {
          clearInterval(deleteTimer!)
          deleteTimer = null
          starPush('/star')
        }
      }, 1000)
    } catch (error: any) {
      message.error(error.message || '网络请求失败')
    } finally {
      confirmConfig.loading = false
      loadingMap.del = false
    }
  }
  confirmConfig.visible = true
}

const handleConfirm = async () => {
  if (!strategyName.value || loadingMap.save) return

  // 显示了优先级选择器时必须选择
  if ((has123(props.aiPriority) || quantType.value == 2) && selectedPriority.value == null) {
    selectError.value = '请选择策略优先级'
    return
  }
  selectError.value = ''

  loadingMap.save = true
  errorMessages.value = []
  const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || store.state.loginInfo.token
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'

  try {
    const actionParam = mode.value === 'save' ? 'save' : 'subsave'

    const res: any = await strategyAction({
      data: {
        taskID,
        action: actionParam,
        name: strategyName.value,
        ...(has123(props.aiPriority) || quantType.value == 2 ? { aiPriority: selectedPriority.value } : {}),
      },
      headers: {
        token,
        username,
      },
    })

    if (res.data.status == 2) {
      // 名称已存在 —— inline 错误
      errorMessages.value.push('该策略名称已存在，请重新输入')
    } else if (res.data.status === 1) {
      // 成功 —— 关闭弹窗，倒计时弹窗显示成功信息
      visible.value = false
      successMessage.value = mode.value === 'subscribe' ? '策略保存成功，你将收到信号推送' : '策略保存成功'
      deleteCountdown.value = 3
      deleteTimer = setInterval(() => {
        deleteCountdown.value--
        if (deleteCountdown.value <= 0) {
          clearInterval(deleteTimer!)
          deleteTimer = null
          starPush('/star')
        }
      }, 1000)
    } else {
      // 3/4/5: 交给 handleBacktestStatus 处理
      visible.value = false
      handleBacktestStatus(res.data.status, res.data.toast, () => {
        visible.value = false
      }, { articleID: res.data.articleID })
    }
  } catch (error: any) {
    message.error(error.message || '网络请求失败')
  } finally {
    loadingMap.save = false
  }
}

onUnmounted(() => {
  if (deleteTimer) clearInterval(deleteTimer)
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "action-footer-container",
    style: _normalizeStyle({ backgroundColor: !__props.isDark ? '#ffffff' : '#1A1A1A' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(pageType) == 1)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "action-btn save-btn",
              loading: loadingMap.save,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('save')))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_unref(pageType) == 2)
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                class: "action-btn gray-btn",
                loading: loadingMap.del,
                onClick: handleDel
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
        (!_unref(isSubscribed))
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              class: "action-btn subscribe-btn",
              loading: loadingMap.sub,
              onClick: handleSub
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["loading"]))
          : (_openBlock(), _createBlock(_component_a_button, {
              key: 3,
              class: "action-btn gray-btn",
              loading: loadingMap.unsub,
              onClick: handleUnsub
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["loading"]))
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      title: null,
      footer: null,
      closable: false,
      width: "360px",
      wrapClassName: 'star-action-modal',
      destroyOnClose: "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", null, _toDisplayString(mode.value === 'save' ? '保存策略' : '订阅信号'), 1)
            ]),
            _createElementVNode("span", {
              class: "star-dialog-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
            }, "✕")
          ]),
          _createElementVNode("div", _hoisted_11, [
            (has123(__props.aiPriority) || _unref(quantType) == 2)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["priority-select-container", { 'has-error': !!selectError.value }])
                }, [
                  _hoisted_12,
                  _createVNode(_component_a_select, {
                    value: selectedPriority.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedPriority).value = $event)),
                    placeholder: "请选择",
                    class: "priority-select",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (selectError.value = ''))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priorityOptions, (opt) => {
                        return _createVNode(_component_a_select_option, {
                          key: opt.value,
                          value: opt.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(opt.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ], 2))
              : _createCommentVNode("", true),
            (selectError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(selectError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["input-container", { 'has-error': _unref(inputErrors).length > 0 }])
            }, [
              _createVNode(_component_a_textarea, {
                value: strategyName.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((strategyName).value = $event)),
                placeholder: "请输入策略名称...",
                class: "custom-input",
                maxlength: 50,
                "auto-size": { minRows: 2, maxRows: 4 },
                onInput: handleInput
              }, null, 8, ["value"])
            ], 2),
            _createElementVNode("div", {
              class: "error-text-container",
              style: _normalizeStyle({ visibility: _unref(inputErrors).length > 0 ? 'visible' : 'hidden' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputErrors), (msg, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "error-text",
                  key: idx
                }, _toDisplayString(msg), 1))
              }), 128))
            ], 4),
            _hoisted_15,
            _createVNode(_component_a_button, {
              class: _normalizeClass(["confirm-btn", { 'is-disabled': !strategyName.value || loadingMap.save }]),
              loading: loadingMap.save,
              onClick: handleConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(mode.value === 'save' ? '确定' : '保存并订阅信号'), 1)
              ]),
              _: 1
            }, 8, ["class", "loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: confirmConfig.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((confirmConfig.visible) = $event)),
      title: null,
      footer: null,
      closable: false,
      width: "320px",
      wrapClassName: 'star-confirm-modal',
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", _hoisted_17, _toDisplayString(confirmConfig.title), 1),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_a_button, {
              class: "confirm-cancel-btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmConfig.visible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "confirm-ok-btn",
              loading: confirmConfig.loading,
              onClick: confirmConfig.onOk
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (deleteCountdown.value > 0)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: true,
          title: null,
          footer: null,
          closable: false,
          width: "320px",
          wrapClassName: 'star-confirm-modal',
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(successMessage.value), 1),
              _createElementVNode("p", _hoisted_23, _toDisplayString(deleteCountdown.value) + " 秒后返回首页", 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(StarTipDialog, {
      tipDialog: _unref(tipDialog),
      showQrDialog: _unref(showQrDialog),
      "onUpdate:showQrDialog": _cache[8] || (_cache[8] = ($event: any) => (_isRef(showQrDialog) ? (showQrDialog).value = $event : null))
    }, null, 8, ["tipDialog", "showQrDialog"])
  ], 4))
}
}

})